/**
 * TanStack Router: /my-evaluation
 *
 * This route file was auto-generated by the route generation script.
 * Component: MyEvaluationPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import MyEvaluationPage from '@/app/my-evaluation/page'

/**
 * Route: /my-evaluation
 * Layout: _auth (authenticated)
 * Component: MyEvaluationPage
 */
export const Route = createFileRoute('/_auth/my-evaluation')({
  component: MyEvaluationPage,
})
